import useTrackNavigation from '../events/useTrackNavigation';
import { useTrackPlatformRestart } from '../events/useTrackPlatformRestart';
import { useTrackPlatformStart } from '../events/useTrackPlatformStart';
import { useTrackUserInfoUpdate } from '../events/useTrackUserInfoUpdate';

import { useTrackAppBaseSnapshot } from './useTrackAppBaseSnapshot';

export const useTrackAppBaseEvents = () => {
    useTrackNavigation();
    useTrackAppBaseSnapshot();
    useTrackUserInfoUpdate();

    // events under ff from config
    useTrackPlatformStart();
    useTrackPlatformRestart();
};
